import Link from 'next/link';
import { MouseEventHandler } from 'react';

interface Props {
  classNames?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
}

const MenuButtonLink: React.FC<Props> = ({ classNames = '', onClick }) => {
  return (
    <div className="relative inline-block">
      <Link
        href="/menu"
        className={`relative bg-gradient-to-r from-orange-600 to-orange-500 text-white px-6 py-2 rounded-full flex justify-between font-medium hover:bg-orange-500 transition-colors duration-200 shadow-lg hover:shadow-xl overflow-hidden ${classNames}`}
        onClick={onClick}>
        {/* Reflection overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent transform -skew-x-12 animate-reflection"></div>

        {/* Button content */}
        <span className="relative z-10">Our Menu</span>
      </Link>
    </div>
  );
};

export default MenuButtonLink;
